/** Risk score weights (plan §0.2 · F8). */
export const RISK_WEIGHT_VOL = 0.5;
export const RISK_WEIGHT_DD = 0.3;
export const RISK_WEIGHT_BETA = 0.2;
